import { apiRequest } from "../api";

export const getUsers = (query: string) => apiRequest(`/users?${query}`, "GET");
export const getUser = (id: string) => apiRequest(`/users/${id}`, "GET");
export const updateUser = (id: string, payload: unknown) =>
  apiRequest(`/users/${id}`, "PUT", payload);
export const deleteUser = (id: string) => apiRequest(`/users/${id}`, "DELETE");
